// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2S743","location":"Header_location__Oe9tW"};